import React, { Fragment } from 'react';

import useListboxFetch from "./useListboxFetch";
import { CommonDropdown } from "./CommonDropdown";
import SpinnerDiv from "ui/ReactSpinnerDiv";

const DropdownALDs = ({ control, name, rules, placeholder, isSearchable, isClearable, isMulti, readOnly, provider_id, onChange } ) =>
{
    const addAll = ( rows ) =>
    {
        const newRows = [ { value: 0, label: 'All'}, ...rows] ;

        return newRows ;
    }

    const fields = { url: '/eyfsn/ald', keyFieldName: 'ald_id', labelFieldName: 'ald_title', postProcessingFn: addAll } ;

    const [ loading, items ] = useListboxFetch( fields ) ;

    return (
        <Fragment>
            { loading === true && <div className='form-control'><SpinnerDiv/></div> }
            { loading === false && <CommonDropdown items={items} control={control} onChange={onChange} name={name} rules={rules} placeholder={placeholder} isSearchable={isSearchable} isClearable={isClearable} isMulti={isMulti} readOnly={readOnly} /> }
        </Fragment>
    )
}

export default DropdownALDs;
